/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-export/itpSignPages.ts
 * FILE_ID: JOBHUB-QA-ITP-SIGN-PAGES-001
 * PURPOSE: Turn a sign-page choice into PDF page numbers, and reserve a signing band.
 */

export type SignPageChoice = 'cover' | 'end' | 'cover-end' | 'all'

export const SIGN_PAGE_CHOICES: { value: SignPageChoice; label: string }[] = [
  { value: 'cover', label: 'Cover page only' },
  { value: 'end', label: 'End page only' },
  { value: 'cover-end', label: 'Cover and end pages' },
  { value: 'all', label: 'All pages' },
]

export function resolveSignPages(choice: SignPageChoice, pageCount: number): number[] {
  const last = Math.max(1, pageCount)
  if (choice === 'end') return [last]
  if (choice === 'cover-end') return last > 1 ? [1, last] : [1]
  if (choice === 'all') return Array.from({ length: last }, (_, index) => index + 1)
  return [1]
}

export const SIGN_BAND_STYLE = '<style id="itp-sign-band">.itp-page > tfoot .itp-page-pad { height: 32mm; } .itp-cover { padding-bottom: 32mm; }</style>'

export function withSignatureBand(html: string): string {
  if (html.includes('id="itp-sign-band"')) return html
  return html.replace('</head>', `${SIGN_BAND_STYLE}</head>`)
}
